module.exports = __webpack_public_path__ + "static/img/222.60b5b71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pro/park/222.png
// module id = TBrQ
// module chunks = 0